import { useLingui } from "@lingui/react/macro";

import { DateInput } from "../../components/ui-kit/fields/date-input";
import { Select } from "../../components/ui-kit/fields/select";
import { TextInput } from "../../components/ui-kit/fields/text-input";
import { FormRow } from "../../components/ui-kit/form/form-row";
import { FormTable } from "../../components/ui-kit/form/form-table";
import { Spinner } from "../../components/ui-kit/spinner";
import { CellDateInput } from "../../components/ui-kit/tables/cell-fields/cell-date-input";
import { SimpleTable } from "../../components/ui-kit/tables/simple-table";
import { clinicalStudies } from "../../constants/enum-to-text";
import { prettyVisitType } from "./utils";

interface VisitData {
  visit_type: string;
  visit_date: string;
}

export const ClinicalStudyEnrollmentFormFields = ({
  enrollmentModel,
  visits,
  onStudyChange,
  onDateChange,
  loading = false,
  prefillLoading = false,
  disabled = false,
}: {
  enrollmentModel: Record<string, unknown>;
  visits: VisitData[];
  onStudyChange: () => void;
  onDateChange: () => void;
  loading?: boolean;
  prefillLoading?: boolean;
  disabled?: boolean;
}) => {
  const { t } = useLingui();
  const study_acronym = enrollmentModel.study_acronym as string | null;
  const enrollment_date = enrollmentModel.enrollment_date as string;

  return (
    <FormTable dataAdd>
      <FormRow
        label={t`Study`}
        data={
          <Select
            values={clinicalStudies}
            attr="study_acronym"
            model={enrollmentModel}
            disabled={disabled}
            onChange={onStudyChange}
            listTitle={t`Select study`}
            required
          />
        }
      />

      <FormRow
        label={t`Enrollment date`}
        data={
          <DateInput
            type="date"
            attr="enrollment_date"
            model={enrollmentModel}
            disabled={disabled}
            onChange={onDateChange}
            required
          />
        }
      />

      {loading || prefillLoading ? (
        <Spinner />
      ) : (
        study_acronym &&
        enrollment_date && (
          <>
            <FormRow
              label={t`Comment`}
              data={
                <TextInput
                  attr="comment"
                  model={enrollmentModel}
                  multiline="autosize"
                />
              }
            />

            <FormRow
              label={t`Visits`}
              data={
                <SimpleTable
                  rows={visits}
                  columns={[
                    {
                      header1: t`Type`,
                      cell: (item) => prettyVisitType(item.visit_type),
                    },
                    {
                      header1: t`Date`,
                      cell: (item) => (
                        <CellDateInput
                          model={item}
                          attr="visit_date"
                          type="date"
                        />
                      ),
                    },
                  ]}
                />
              }
            />
          </>
        )
      )}
    </FormTable>
  );
};
